import { gsap, ScrollTrigger, screenSm } from './1.1_animations-defaults.js';
import { projectSwiper } from './4.1_swipers-project.js';

const SECTION_ID = 'project-slider';
const SLIDER_WRAPPER_CLASS = 'slider-wrapper';
const SLIDER_WRAPPER_ACTIVE_CLASS = 'slider-wrapper--active';

class AnimationsProjectSlider {
    constructor() {
        this._section = document.getElementById(SECTION_ID);

        this._section && this._run();
    }
    _run = () => {
        this._media = gsap.matchMedia();

        this._sliderWrapper = this._section.querySelector(`.${SLIDER_WRAPPER_CLASS}`);

        this._media.add(
            {
                isDesktop: `(min-width: ${screenSm}px)`,
                isMobile: `(max-width: ${screenSm - 1}px)`,
                reduceMotion: '(prefers-reduced-motion: reduce)',
            },
            this._createAnimationTimeline,
        );
    };

    _createAnimationTimeline = (context) => {
        let { isDesktop, isMobile, reduceMotion } = context.conditions;
        let parentObj = this;
        //ScrollTrigger.refresh();
        // gsap.set(this._sliderWrapper, {
        //     opacity: 0,
        //     xPercent: 100,
        // });
        gsap.to(this._sliderWrapper, {
            x: 0,
            opacity: 1,
            duration: isDesktop ? 0.7 : 0.5,
            ease: 'sliderEase',
            // ease: 'none',
            scrollTrigger: {
                trigger: this._section,
                toggleActions: 'play none none reverse',
                start: '-=10% bottom',
                end: '-=10% bottom',
                markers: false,
                //scrub: 1,
                scrub: false,
            },
            onUpdate: function () {
                if (this.progress() >= 0.5) {
                    parentObj._sliderWrapper.classList.add(SLIDER_WRAPPER_ACTIVE_CLASS);
                } else {
                    parentObj._sliderWrapper.classList.remove(SLIDER_WRAPPER_ACTIVE_CLASS);
                }
            },
            onComplete: () => {
                projectSwiper.update();
            },
        });
    };
}
const animationsProjectSlider = new AnimationsProjectSlider();
